import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, EmailAuthProvider } from 'firebase/auth';

// Firebase configuration - ppl-contact project
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyC36o6X3IXfYS9TjKt6F5DhezL9oLhmMkE",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "ppl-contact.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "ppl-contact",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "ppl-contact.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "377890489670",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:377890489670:web:3dca3c32fb19ddfcc05147"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Google Auth Provider
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

// Email/Password Auth Provider
export const emailProvider = new EmailAuthProvider();

export default app; 